import { Component, ViewContainerRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ModalComponent } from "../../../modal/modal.component";
import { AdvancedFilterComponent } from "../../../advanced-filter/advanced-filter.component";
import { TableListRequest, Where } from "../../../../models/table-list-request.interface";
import { NoDataComponent } from "../../../no-data/no-data.component";
import { NoDataFoundComponent } from "../../../no-data-found/no-data-found.component";
import { ResizableModule, ResizeEvent } from "angular-resizable-element";
import { SvgIconComponent } from "../../../svg-icon/svg-icon.component";
import { TableMenuComponent } from "../../../table-menu/table-menu.component";
import { PaginatedListDataResponse } from "../../../../models/paginated-list-data-response";
import { LoadingService } from "../../../../services/loading.service";
import { OperationService } from "../../../../services/operations.service";
import { User } from "../../../../models/user.interface";
import { SharedModule } from "../../../../modules/shared/shared.module";
import { InventoryService } from "../../../../services/inventory-service";
import { HighlightPipe } from "../../../../pipes/highlight.pipe";
import { ActivatedRoute, Router } from "@angular/router";
import { TosTableComponent } from "../../../tos-table/tos-table.component";
import containerPageConfig from "../config/container-page-config.json";
import { TableMeta } from "../../../../models/table-meta.interface";
import { AdvancedFilterComponentV2 } from "../../../advanced-filter/advanced-filter-v2.component";
import { FieldInfo } from "../../../../models/editable-table-header.interface";

@Component({
  selector: 'app-container-listing',
  standalone: true,
  imports: [
    FormsModule,
    SharedModule,
    SvgIconComponent,
    HighlightPipe,
    TableMenuComponent,
    ResizableModule,
    NoDataFoundComponent,
    NoDataComponent,
    TosTableComponent,
  ],
  templateUrl: './container-listing.component.html',
  styleUrl: './container-listing.component.scss',
})
export class ContainerListingComponent {
  protected readonly containerPageConfig = containerPageConfig;

  filterFields = [
    {
      displayName: 'Container Number',
      key: 'containerNo',
    },
  ];
  isFilterApplied: boolean = false;
  searchTerm: any;
  focusSearch!: boolean;
  tableMeta!: TableMeta;
  tableLoaded: boolean = false;
  tableListData: PaginatedListDataResponse = {
    totalCount: 0,
    page: 0,
    limit: 0,
    records: [],
  };

  filterData: Where | null = null;
  rawFilterData: Where | null = null;
  searchFilterData!: Where | null;
  sortColumn: string = 'modifiedDate';
  openMenuIndex: number | null = null;
  menuOptions = [
    { label: 'Edit', value: 'edit' },
    { label: 'View', value: 'view' },
  ];
  totalTablePages: number = 0;
  currentTablePage: number = 1;
  sortDirection: 'asc' | 'desc' = 'desc';
  rowsPerPage: number = 25;
  currentPage: number = 0;
  tableListRequest: TableListRequest = {
    selectFields: [
      'id',
      'containerNo',
      'containerSize',
      'containerType',
      'vesselId',
      'shippingLineId',
      'gateInDate',
      'hazardous',
      'reeferPlugin',
      'odc',
      'modifiedDate',
    ],
    orderBy: {
      [this.sortColumn]: this.sortDirection,
    },
    limit: this.rowsPerPage,
    page: this.currentPage,
  };
  allTableRecordsSelected: boolean = false;
  selectedItems: any[] = [];
  previousTerm: string = '';

  defaultFilters: Where = {
    filterConditions: [
      {
        name: 'IS_GATED_IN',
        alias: 'gateInDate',
        value: ['true'],
      },
    ],
    expression: 'gateInDate',
  };

  constructor(
    private viewContainerRef: ViewContainerRef,
    private loadingService: LoadingService,
    private inventoryService: InventoryService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.tableMeta = containerPageConfig.containerTableConfig;
  }

  ngOnInit() {
    this.fetchAllRecords();
  }

  fetchAllRecords() {
    this.loadingService.show('inline');
    this.inventoryService.getContainerList(this.tableListRequest).subscribe({
      next: (res: any) => {
        this.tableListData = res.data;
        this.tableLoaded = true;
        this.loadingService.hide();
      },
      error: (error: Error) => {
        console.error('Error occurred:', error);
        this.tableLoaded = false;
        this.loadingService.hide();
      },
    });
  }






  isSelected(item: any) {
    if (this.allTableRecordsSelected) {
      return true;
    } else {
      const recordIdx = this.selectedItems.findIndex((x) => x.id === item.id);
      if (recordIdx !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }

  toggleSelection(item: any) {
    if (!this.isSelected(item)) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);
    }
  }

  handleMenuToggle(i: number) {
    this.openMenuIndex = this.openMenuIndex === i ? null : i;
  }

  handleOptionSelected(record: any, actionName: any) {
    console.log(record);
    const recordId = record.id;
  }

  handleMenuOptionSelection(event: any) {
    console.log('evemt: ', event);
    const { record, actionName } = event;
    const recordId = record.id;
    if (actionName === 'edit') {
      this.router.navigate([`edit/${recordId}`], { relativeTo: this.route });
    } else if (actionName === 'view') {
      this.router.navigate([`view/${recordId}`], { relativeTo: this.route });
    }
  }

}
